export default __webpack_public_path__ + "static/media/istockphoto-1223195737-612x612.a329232c.jpg";